import React from 'react';
import { useTranslation } from 'react-i18next';
import { Check } from 'lucide-react';
import { Button, SectionHeading } from '../components/ui';
import Seo from '../components/Seo';
import { getStaticMeta } from '../seo/pageMeta';

const NinjaTraderScreen = () => {
  const { t, i18n } = useTranslation();
  const meta = getStaticMeta('ninjatrader', i18n.language);

  return (
    <div className="min-h-screen bg-bg pt-28 pb-24 md:pt-32">
      <Seo title={meta.title} description={meta.description} path="/ninjatrader" />
      <div className="mx-auto max-w-page px-6">
        <section className="rounded-card border border-white/[.08] bg-surface">
          <div className="grid items-start gap-10 px-6 py-10 md:grid-cols-12 md:gap-14 md:px-10 md:py-14">
            <div className="md:col-span-4">
              <img
                src="/images/Logos/NinjaTrader/NinjaTrader_Wordmark_color_RGB.png"
                alt="NinjaTrader"
                className="mb-8 h-10"
              />
              <img
                src="/images/Logos/NinjaTrader/NinjaTrader_Monitor_Image.png"
                alt="NinjaTrader Platform"
                className="w-full"
              />
            </div>

            <div className="md:col-span-8">
              <SectionHeading
                title={t('ninjatrader.title')}
                subtitle={t('ninjatrader.description')}
                className="mb-8"
              />

              <div className="mb-6 rounded-card border border-white/[.06] bg-bg/50 p-5">
                <h2 className="mb-4 text-left text-base font-semibold text-body">
                  <a
                    href="https://ninjatraderdomesticvendor.sjv.io/Bn6731"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-body underline-offset-4 hover:underline"
                  >
                    {t('ninjatrader.downloadTitle')}
                  </a>
                  <span> {t('ninjatrader.downloadSubtitle')}</span>
                </h2>
                <ul className="space-y-2.5 text-sm text-muted">
                  {t('ninjatrader.features', { returnObjects: true }).map((feature, index) => (
                    <li key={index} className="flex items-start">
                      <Check className="mr-3 mt-0.5 h-3.5 w-3.5 shrink-0 text-primary" aria-hidden="true" />
                      <span>{feature}</span>
                    </li>
                  ))}
                </ul>
              </div>

              <p className="mb-8 text-sm leading-relaxed text-muted md:text-base">
                {t('ninjatrader.platformDescription')}
              </p>

              <Button
                href="https://ninjatraderdomesticvendor.sjv.io/Bn6731"
                target="_blank"
                rel="noopener noreferrer"
              >
                {t('ninjatrader.cta.download')}
              </Button>
            </div>
          </div>
        </section>

        <section className="mt-px rounded-card border border-white/[.08] border-t-0 bg-surface md:rounded-t-none">
          <div className="grid items-start gap-10 px-6 py-10 md:grid-cols-12 md:gap-14 md:px-10 md:py-14">
            <div className="md:col-span-4">
              <img
                src="/images/Logos/Kinetick/Kinetick_Logo.png"
                alt="Kinetick"
                className="mb-8 h-16"
              />
              <img
                src="/images/Logos/Kinetick/Kinetick_Badge.png"
                alt="Kinetick Badge"
                className="w-full max-w-xs"
              />
            </div>

            <div className="md:col-span-8">
              <SectionHeading title={t('ninjatrader.kinetick.title')} className="mb-6" />
              <p className="mb-4 text-sm leading-relaxed text-muted md:text-base">
                {t('ninjatrader.kinetick.description1')}
              </p>
              <p className="mb-8 text-sm leading-relaxed text-muted md:text-base">
                {t('ninjatrader.kinetick.description2')}
              </p>
              <Button
                href="https://kinetick.com/NinjaTrader"
                target="_blank"
                rel="noopener noreferrer"
              >
                {t('ninjatrader.cta.data')}
              </Button>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default NinjaTraderScreen;
